/**
 * Generic modal
 * @method setConfirmModal
 */
export function ModalController() {
    //generic
    this.confirmModal = null
    this.successModal = null
    this.serialModal = null
    this.pdpaContentModal = null
    this.alertModal = null
    this.loadingModal = null

    //#region generic
    this.setConfirmModal = function (confirmModalController) {
        this.confirmModal = confirmModalController;
    };
    this.setSuccessModal = function (successModalController) {
        this.successModal = successModalController;
    };
    this.setSerialModal = function (serialModalController) {
        this.serialModal = serialModalController;
    };
    this.setPdpaContentModal = function (pdpaContentModalController) {
        this.pdpaContentModal = pdpaContentModalController;
    };
    this.setAlertModal = function (alertModalController) {
        this.alertModal = alertModalController;
    }
    this.setLoadingModal = function (loadingModalController) {
        this.loadingModal = loadingModalController;
    }
    //#endregion generic
}
